import React, { useEffect, useRef, useState } from "react";

const Results = () => {
  const [visible, setVisible] = useState(false);
  const sectionRef = useRef();

  // ✅ Your Images
  const largeImages = [
    "/result/result h1.jpeg",
     "/result/result h2.jpeg",
   "/result/result h3.jpeg", 
   "/result/result h4.jpeg",
     "/result/result h5.jpeg",
   "/result/result h6.jpeg"
  ];

  const smallImages = [
    "/result/result v1.jpeg",
    "/result/result v2.jpeg",
    "/result/result v3.jpeg",
    "/result/result v4.jpeg",
    "/result/result v5.jpeg",
    "/result/result v6.jpeg", 
    "/result/result v6.jpeg",
  ];

  useEffect(() => {
    const obs = new IntersectionObserver(
      ([e]) => e.isIntersecting && setVisible(true),
      { threshold: 0.2 }
    );
    if (sectionRef.current) obs.observe(sectionRef.current);
    return () => obs.disconnect();
  }, []);

  return (
    <div
      ref={sectionRef}
      className="relative min-h-screen bg-gradient-to-br from-indigo-100 via-purple-100 to-pink-100 overflow-hidden py-16"
    >

      {/* Background Effects */}
      <div className="pointer-events-none absolute inset-0">
        {Array.from({ length: 25 }).map((_, i) => (
          <span
            key={i}
            className="absolute w-1 h-1 bg-white rounded-full opacity-60 animate-pulse"
            style={{
              top: `${Math.random() * 100}%`,
              left: `${Math.random() * 100}%`,
            }}
          />
        ))}
      </div>

      {/* Glow */}
      <div className="absolute -top-20 left-0 w-80 h-80 bg-purple-300 opacity-20 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-0 w-80 h-80 bg-pink-300 opacity-20 rounded-full blur-3xl"></div>

      <div className="max-w-6xl mx-auto px-4 relative z-20">

        {/* HERO */}
        <div
          className={`text-center transition-all duration-1000 ${
            visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
          }`}
        >
          <h1 className="text-4xl sm:text-5xl md:text-6xl font-extrabold bg-clip-text text-transparent bg-gradient-to-r from-purple-700 via-indigo-700 to-purple-700">
            Our Top Results 🎉
          </h1>

          <p className="mt-4 text-gray-700 max-w-2xl mx-auto text-sm sm:text-lg">
            Celebrating the achievements of our students.
          </p>
        </div>

        {/* ✅ LARGE IMAGES */}
        <div className="mt-16">
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-6 text-center">
            Top Performers
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {largeImages.map((img, i) => (
              <div
                key={i}
                className="group bg-white rounded-2xl p-3 shadow-lg hover:shadow-2xl transition duration-500"
              >
                <img
                  src={img}
                  alt="Topper"
                  className="
                    w-full 
                    h-auto 
                    max-h-[500px]
                    object-contain 
                    rounded-xl
                    transition-transform duration-500
                    group-hover:scale-105
                  "
                />
              </div>
            ))}
          </div>
        </div>

        {/* ✅ SMALL IMAGES */}
        <div className="mt-14">
          <h2 className="text-xl sm:text-2xl font-semibold text-gray-700 mb-5 text-center">
            More Highlights
          </h2>

          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
            {smallImages.map((img, i) => (
              <div
                key={i}
                className="group bg-white p-2 rounded-xl shadow-md hover:shadow-xl transition duration-300"
              >
                <img
                  src={img}
                  alt="Highlight"
                  className="
                    w-full 
                    h-auto 
                    max-h-[250px]
                    object-contain 
                    rounded-lg
                    transition-transform duration-300
                    group-hover:scale-105
                  "
                />
              </div>
            ))}
          </div>
        </div>

      </div>
    </div>
  );
};

export default Results;